"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'slotData.create.success': 'Dati slot creati con successo',
    'slotData.create.error': 'Errore nella creazione dei dati slot',
};
